import { useBootstrapApiBase } from '../api';
import { CreditUsageTitle } from '../constants';
import { CreditUsage, CreditUsageType } from '../definition';

interface UseCreditUsageItemsReturn {
  items: CreditUsage[];
  isLoading: boolean;
}

export function useCreditUsageItems(
  filterArr?: CreditUsageType[]
): UseCreditUsageItemsReturn {
  const api = useBootstrapApiBase();

  if (!api.data?.cost) {
    return { items: [], isLoading: api.isLoading };
  }

  const items = (Object.keys(api.data.cost) as CreditUsageType[])
    .filter((key) => key in CreditUsageTitle)
    .filter((key) => (filterArr ? filterArr.includes(key) : true))
    .sort((a, b) =>
      (filterArr?.indexOf(a) ?? 0) > (filterArr?.indexOf(b) ?? 0) ? 1 : -1
    )
    .map((key) => ({
      credit: api.data?.cost[key],
      title: CreditUsageTitle[key],
      type: key,
    }));

  return { items, isLoading: api.isLoading };
}
